var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('grid',{attrs:{"config":_vm.config,"classes":_vm.classes,"disabled":_vm.disabled},on:{"select":_vm.updateModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }